<div class="container">
	@if (data.label) {
		<div class="heading">{{ data.label }}</div>
	}
	<div class="option-group">
		<div class="option-header">
			{{ data.optieAHeader }}
		</div>
		<div class="options">
			@for (option of data.optiesA; track option) {
				<div class="option" [class.is-selected]="isSelectedA(option)" (click)="changeA(option)">
					<span class="option-text">{{ option.text }}</span>
					@if (isSelectedA(option)) {
						<app-icon name="check" color="primary-1" size="smallest"></app-icon>
					}
				</div>
			}
		</div>
	</div>
	<div class="option-group">
		<div class="option-header">
			{{ data.optieBHeader }}
		</div>
		<div class="options">
			@for (option of data.optiesB; track option) {
				<div class="option" [class.is-selected]="isSelectedB(option)" (click)="changeB(option)">
					<span class="option-text">{{ option.text }}</span>
					@if (isSelectedB(option)) {
						<app-icon name="check" color="primary-1" size="smallest"></app-icon>
					}
				</div>
			}
		</div>
	</div>
</div>
